module.exports = __webpack_public_path__ + "img/aqt-zs.9ad063dc.png";